import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden ${noPadding ? '' : 'p-6'} ${className}`} {...props} data-id="element-3999" data-mp="89vdhqu05l1s">
      {children}
    </div>;
}